export default __webpack_public_path__ + "f588feb3cbbcc0fb259a3630ec7e34ba.svg";